module.exports = __webpack_public_path__ + "img/corn-snack.08aa906a.png";